import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from "../../apis/commonAPI";
import { PAGE_LIMITS, modulePermissions } from "../../constants";
import Loader from "../../components/loader";
import Table from "../../components/tables/table";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { expertFieldsData,expertTableData } from "../../data/TableData";
import useUser from "../../hooks/useUser";
import useAxios from "../../hooks/useAxios";


const MODULE_URI = "/expert/expertListing";
const FETCH_API_URL = 'expert/getexpertlisting?';
const CHANGE_STATUS_API_URL = `customer/change-customer-status?dataId=`;
export default function ExpertListing() {
  
  const [searchParams, setSearchParams] = useSearchParams();
  const expertStatus = searchParams.get("expertStatus");

  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(PAGE_LIMITS[0]);
    const [totalCount, setTotalCount] = useState(0);
  
  const [tableData, setTableData] = useState([]);
  const [addUpdate, setAddUpdate] = useState(false);

  
//   const { modulePermissions } = useUser(MODULE_URI);
  const [resData, error, loading, axiosFetch] = useAxios();
  const [resStatusData, errorStatus, loadingStatus, axiosFetchStatus] = useAxios();

  console.log("resData",resData)

  useEffect(() => {
    if (expertStatus === "registered") {
      toast.success("Expert registered successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (expertStatus === "update") {
      toast.success("Expert updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }, [expertStatus]);

  const getData = (url) => {
    axiosFetch({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };

  const handleSearchFieldChange = (e) => {
    if (e.key === "Enter") {
      setSearch(e.target.value);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(e.target.value);
  };

  

 useEffect(() => {
   
    getData(`${FETCH_API_URL}search=${search}&skip=${page > 0 ? page * limit : 0}&limit=${limit}`)

  }, [FETCH_API_URL,loadingStatus,search, page, limit]);

console.log("resData",resData)
  useEffect(() => {
    if (resData?.[0]?.success !== false && resData?.length > 0) {
      const tempData = resData?.[0]?.data?.map((item) => {
        return {
          _id: item._id,
          expertName: item.expertName,
          phone: item.email,
          domain: item.domainName,
          email: item.email,
          phone: item.phone,
          subDomain: item?.subDomain
          ?.map(sub => sub.subDomainName)
          .filter(name => !!name)
          .join(', '),
          status: item.status,
        
        };
      });

      setTableData(tempData);
      setTotalCount(resData?.[0]?.totalCount)

    } else {
      if( resData?.[0]?.success === false) {
        toast.error("No data found", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      setTableData([]);
      setTotalCount(0)

    }
  }, [resData]);
//   console.log("table data",tableData)
function navigateToExpAvailPage(rowIndex) {
    if (rowIndex >= 0) {
      
      const currItem = tableData[rowIndex];
      navigate(`${MODULE_URI}/manageexpertAvailability/${currItem?._id}`);
    } else {
      navigate(MODULE_URI);
    }
  }
function navigateToExpBookedSlot(rowIndex) {
    if (rowIndex >= 0) {
      
      const currItem = tableData[rowIndex];
      navigate(`${MODULE_URI}/manageexpertslotbooking/${currItem?._id}`);
    } else {
      navigate(MODULE_URI);
    }
  }

  const handleStatus = async (rId, status,id) => {
      await axiosFetchStatus({
        axiosInstance: axiosInstance,
        url: `expert/updateExpertStatusData/${rId}`,
        method: "POST",
        requestConfig: {
          data: {
            status,
          },
        },
      });
      setAddUpdate(true);
  
     
    };
    function navigateToEditPage(rowIndex ) {
      console.log("test row index",tableData[rowIndex])
      if (rowIndex >= 0) {
        const currItem = tableData[rowIndex];
        navigate(`${MODULE_URI}/edit/${currItem?._id}`);
      } else {
        navigate(MODULE_URI);
      }
    }
  

  return (
    <>
    <div className="card min-height-100">
      <div className="pump-report-top">
        <h2 className="text-navyBlue">Expert List</h2>
        <ToastContainer />

        <div className="btn-wrapper">
          {modulePermissions?.canAdd && (
            <Link
              to={`${MODULE_URI}/add`}
              className="btn btn-sm btn-blue rounded-10"
              title="click to add expert"
            >
              Add Expert
            </Link>
          )}

          {/* {modulePermissions.canDownload && (
            <button className="btn btn-sm btn-green rounded-10">
              Download Data
            </button>
          )} */}
        </div>
      </div>

      {/* {loading && <Loader />} */}

      {/* {!loading && error && (
        <div className="label label-block label-red-bg rounded-10 mt-10 mb-10">
          {error || "Something went wrong!!"}
        </div>
      )} */}

      <div className="pump-search">
        <span className="text-gray">
          {" "}
          Show Entries
          <select
            type="text"
            className="p-5 rounded-20 ml-10 no-bg border-darkGray text-gray"
            onChange={handleLimitChange}
          >
            {PAGE_LIMITS.map((value, index) => (
              <option key={index} value={value}>
                {value}
              </option>
            ))}
          </select>
        </span>

        <span>
          {" "}
          <input
            type="text"
            className="p-5 rounded-20 ml-10 no-bg border-darkGray text-gray"
            placeholder="Search"
            onKeyDown={handleSearchFieldChange}
          />
        </span>
      </div>
      <div className="company-table ">
        <Table
          tableColumns={expertFieldsData}
          tableData={tableData}
          tableSettings={{
            page,
            pageSize: limit,
            totalCount,
          }}
          action={true}
          modulePermissions={modulePermissions}
  
          handlePage={setPage}
          handleCustAssetFlag = {true}
          handleExpAvalFlag = {true}
          handleExpAvailability = {navigateToExpAvailPage}
          handleExpBookedSlotFlag = {true}
          handleExpBookedSlot = {navigateToExpBookedSlot}
          handleStatus={handleStatus}
          handleEdit={navigateToEditPage}

          // handleExpBookedSlotFlag = {true}


          
        />
      </div>
    </div>
    </>
    
  );
}
